
import { defineComponent, ref, onMounted } from 'vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { keieiJohoRepositories } from '@/repositories/keiei-joho/keieiJohoRepositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { TaishakuTaishoUiItem } from '@/views/keiei-joho/data'
import { UiItemsLogic } from '@/views/fuzoku-meisai/uiItemsLogic'
import { taishakuTaishoElementTypeType, TaishakuTaishoElementTypeType, outputFundTypeType, OutputFundTypeType, taishakuTaishoKmkTypeType } from '@/repositories/keiei-joho/data'
import TaishakuTaishoSettingItem from '@/views/keiei-joho/taishaku-taisho/TaishakuTaishoSettingItem.vue'
import { corporationTypeType, CorporationTypeType } from '@/views/corporation-info/types'
const repository = keieiJohoRepositories.taishakuTaishoSetting

export default defineComponent({
  components: {
    TaishakuTaishoSettingItem,
    ResponseResultAlert,
    ContentLayout,
    LoadingButton
  },
  setup () {
    const loading = ref(false)
    const isSucceedRequest = ref(false)
    const requestError = ref<string | null>(null)
    const hasError = ref<boolean>(false)
    const shisanItems = ref<TaishakuTaishoUiItem[]>([])
    const fusaiItems = ref<TaishakuTaishoUiItem[]>([])
    const junShisanItems = ref<TaishakuTaishoUiItem[]>([])
    const outputFundType = ref<OutputFundTypeType>(outputFundTypeType.Shushikin)
    const corporationType = ref<CorporationTypeType>(corporationTypeType.Type1)

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        const hasCorporationInfo = await repository.checkCorporationInfoExists()
        if (!hasCorporationInfo) {
          requestError.value = '法人情報が登録されていません。法人情報画面から登録してください。'
          loading.value = false
          hasError.value = true
          return
        }
        await refreshUiData()
      })
      loading.value = false
    })

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()

      await callApiWrapper(requestError, async () => {
        let params = shisanItems.value.map(v => v.item)
        params = params.concat(fusaiItems.value.map(v => v.item))
        params = params.concat(junShisanItems.value.map(v => v.item))
        await repository.save(params, outputFundType.value)
        await refreshUiData()
        isSucceedRequest.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedRequest.value = false
      requestError.value = null
    }

    const onChangeInput = (type: TaishakuTaishoElementTypeType, item: TaishakuTaishoUiItem) => {
      const items = getUiItems(type)
      UiItemsLogic.updateUiItem(items, item)
    }

    const getUiItems = (type: TaishakuTaishoElementTypeType): TaishakuTaishoUiItem[] => {
      switch (type) {
        case taishakuTaishoElementTypeType.Shisan:
          return shisanItems.value
        case taishakuTaishoElementTypeType.Fusai:
          return fusaiItems.value
        case taishakuTaishoElementTypeType.Junshisan:
          return junShisanItems.value
        default:
          throw Error('unknown type')
      }
    }

    const refreshUiData = async () => {
      const data = await repository.list()
      const sItems = data.items.filter(v => v.elementType === taishakuTaishoElementTypeType.Shisan).map(value => ({ item: value, isValid: true }))
      const fItems = data.items.filter(v => v.elementType === taishakuTaishoElementTypeType.Fusai).map(value => ({ item: value, isValid: true }))
      const jItems = data.items.filter(v => v.elementType === taishakuTaishoElementTypeType.Junshisan).map(value => ({ item: value, isValid: true }))
      if (data.corporationType === corporationTypeType.Type1) {
        shisanItems.value = sItems.filter(v => v.item.isRequiredSettingType1)
        fusaiItems.value = fItems.filter(v => v.item.isRequiredSettingType1)
        junShisanItems.value = jItems.filter(v => v.item.isRequiredSettingType1)
      } else {
        shisanItems.value = sItems.filter(v => v.item.isRequiredSettingType2To5)
        fusaiItems.value = fItems.filter(v => v.item.isRequiredSettingType2To5)
        junShisanItems.value = jItems.filter(v => v.item.isRequiredSettingType2To5)
      }
      outputFundType.value = data.outputFundType
      corporationType.value = data.corporationType
    }

    return {
      loading,
      isSucceedRequest,
      requestError,
      hasError,
      shisanItems,
      fusaiItems,
      junShisanItems,
      outputFundType,
      corporationType,
      corporationTypeType,
      taishakuTaishoKmkTypeType,
      taishakuTaishoElementTypeType,
      outputFundTypeType,
      onClickRegister,
      onDismissAlert,
      onChangeInput
    }
  }
})
